import {DocTypeEnum, documentHelper, DocVersionEnum, ProductsEnum} from "@ferry/journey-services";
import {resourcesHelper} from "@ferry/portal-core";
import * as React from "react";
import * as moment from "moment";
import {Link} from "react-router-dom";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";

interface IProps {
    unpaidChangeDueDate: string;
    interaction: any;
}

export class UnpaidChangeBanner extends React.Component<IProps> {
    private basePath = "/resources/documents/";
    private readonly version: DocVersionEnum | null;

    constructor(props: IProps) {
        super(props);
        const startDateString = this.props.interaction.renewalDetails?.periodStartDate ?? this.props.interaction.factors.originalQuoteDate;
        const startDate = new Date(startDateString);

        this.version = documentHelper.getDocumentVersionByDateAndType(startDate, DocTypeEnum.DOI)
    }

    getDOIPath(){
        return `${this.basePath}/${resourcesHelper.THEME}/${this.version}/${resourcesHelper.THEME}_DOI.pdf`
    }

    public render() {

        const { interaction, unpaidChangeDueDate } = this.props;

        if (interaction.paymentDetails?.submittedForSettlement) {
            // Payment was already processed. Without that condition banner is still present after payment, until customer relogin.
            return null;
        }


        const paymentChoice = "/journey/init/product/AnnualMotorInsurance/process/mtaClaimImpact/presetPage/" + this.props.interaction._id;

        const additionalPremium = interaction.factors.additionalPremium;
        const dueDate = moment.utc(unpaidChangeDueDate, moment.ISO_8601);
        const todayDate = moment.utc(moment().toDate(), moment.ISO_8601);
        const daysLeft = dueDate.diff(todayDate, 'days') + 1;

        return (
            <div className="inner-container">
                <div className="banner warning-banner">
                    <div className="banner-icon" />
                    <div className="banner-text">
                        Due to your recent claim and as per&nbsp;
                        <a href={`${this.getDOIPath()}`} download={`${resourcesHelper.THEME_NAME} Car Document of Insurance (DOI)`}>T&Cs
                        </a>
                        &nbsp;there is an outstanding balance of&nbsp;
                        <span className="font-weight-bold">{getAmountWithDecimalDigits(additionalPremium)}</span>
                        &nbsp;left to pay. You have {daysLeft} days to make this payment or your car insurance may be cancelled.
                        <div>
                            <Link id="payNow"
                                  className="btn btn-white-dashboard"
                                  state={{
                                      verifyCardFailed: false,
                                      product: ProductsEnum.WOLF_MOTOR
                                  }}
                                  to={{
                                      pathname: paymentChoice,
                                  }}>
                                Pay {getAmountWithDecimalDigits(additionalPremium)} now
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
